/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCrane = createReactComponent("crane", "IconCrane", [
  ["path", { d: "M6 21h6", key: "svg-0" }],
  ["path", { d: "M9 21v-18l-6 6h18", key: "svg-1" }],
  ["path", { d: "M9 3l10 6", key: "svg-2" }],
  ["path", { d: "M17 9v4a2 2 0 1 1 -2 2", key: "svg-3" }]
]);

export { IconCrane as default };
//# sourceMappingURL=IconCrane.js.map
